import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from "@angular/core";
import { BvSpace, spaceVar } from "./types";

/**
 * CSS grid wrapper.
 *
 * - `cols` as a number: fixed N equal columns (`repeat(N, 1fr)`).
 * - `cols="auto-fill"`: responsive columns sized to fit `minColWidth`.
 */
@Component({
    selector: "bv-grid",
    template: "<ng-content></ng-content>",
    styles: [
        `
      :host {
        display: grid;
        min-width: 0;
      }
    `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BvGridComponent {
  @Input() cols: number | "auto-fill" = 1;
  @Input() minColWidth = "220px";
  @Input() gap: BvSpace = "0";

  @HostBinding("style.grid-template-columns")
  get colsStyle(): string {
    if (this.cols === "auto-fill") {
      return `repeat(auto-fill, minmax(${this.minColWidth}, 1fr))`;
    }
    return `repeat(${this.cols}, minmax(0, 1fr))`;
  }

  @HostBinding("style.gap")
  get gapStyle(): string {
    return spaceVar(this.gap);
  }
}
